import ContentScreenConnector from './ContentScreenConnector';

export default ContentScreenConnector;
